export const fromRecipe = row => Number(row.bxrectype) === 11;
export const materialKey = row => `${Number(row.bxpart_id)}:${Number(row.bxum_id)}`;

// Match the existing SIMAUS norm import: whole production units, rounded up.
export function recipeMaterials(recipe, quantity) {
  const units = Math.max(0, Math.ceil(Number(quantity) || 0));
  const grouped = new Map();
  for (const line of recipe?.linii || []) {
    const key = `${Number(line.material_id)}:${Number(line.um_id)}`;
    const row = grouped.get(key) || { ...line, cantitate: 0 };
    row.cantitate += Number(line.cantitate) || 0;
    grouped.set(key, row);
  }
  return [...grouped.values()].map(line => ({
    bxpart_id: line.material_id, bxum_id: line.um_id,
    part_code: line.material_cod_str || '', part_name: line.material_denumire || '',
    um_name: line.um_denumire || '', bxnorma: line.cantitate,
    deluat: Number((line.cantitate * units).toFixed(12)),
    bxrectype: 11, bxegal: 0, luat: 0, qty_proforma: 0,
    bxrestqty: Number((line.cantitate * units).toFixed(12)),
    pret_magazie: null, pretvanzare: 0, bxremiza: 0, inchid_fortat: 0,
  }));
}

export function localDate() {
  const date = new Date();
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function addRecipeMaterial(rows, material) {
  if (!Number.isFinite(Number(material.deluat)) || !(material.deluat > 0)) return rows;
  return [...rows, { ...material, data_scadere: material.data_scadere || localDate() }];
}

export function updateMaterialQuantity(row, value) {
  return { ...row, deluat: value,
    bxnorma: fromRecipe(row) ? row.bxnorma : value,
    bxrestqty: Math.max(0, Number(value || 0) - Number(row.luat || 0)) };
}
